import { useIsMutating, useMutation } from 'react-query'

import { logMessage } from '../../../../Logging/log'
import { uploadHandout } from '../api/upload'

const useStartUploadHandout = (liveId: number) => {
  return useMutation({
    mutationKey: ['uploadHandout'],
    mutationFn: async (file: File) => {
      const {
        filename,
        size: fileSize,
        icon_name: iconName,
      } = await uploadHandout(liveId, file)
      return {
        filename,
        fileSize,
        iconName,
      }
    },
    onError: (error) => {
      logMessage('Error uploading handout', {
        level: 'error',
        extra: { reason: error },
      })
    },
  })
}

const useIsUploadingHandout = () => useIsMutating(['uploadHandout']) > 0

export { useStartUploadHandout, useIsUploadingHandout }
